<template>
  <div class="careforsociety">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div
      class="container mobile-hide"
      style="
    height: 150px;
    background: url(./img/careforsociety_bottom.png)center center /cover;"
    ></div>
    <div class="container mobile-padding" style="text-align:left;margin-bottom:30px;">
      <div class="columns">
        <div class="column blue-title" style="padding-bottom:0;">
          <span>{{$t('body.care_title')}}</span>
          <div class="subtitlebodyblue">{{$t('body.care_p1')}}</div>
        </div>
      </div>
    </div>
    <div
      class="container mobile-padding"
      style="text-align:left;margin-top:16px;margin-bottom:30px;"
    >
      <div class="columns bodygrey">
        <div class="column mobile-column-padding-right mobile-column-padding-bottom">
          <div>{{$t('body.care_p2')}}</div>
        </div>
        <div class="column">
          <div>{{$t('body.care_p3')}}</div>
        </div>
      </div>
    </div>
    <u-animate-container>
      <u-animate
        name="fadeInUp"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div class="container">
          <div class="columns" v-for="(items, index) in cares" :key="index">
            <div
              v-for="(item, index) in items"
              :key="index"
              @mouseenter="hilightTableIn"
              @mouseleave="hilightTableOut"
              class="column hilight-table"
              :style="{backgroundImage: `url(${item.link})`}"
              style="
          background-position: center;
          background-size: cover;
          height:300px;
          border: solid white 4px;"
            >
              <div class="bodywhite">
                <div>{{$t('body.news_np1')}}</div>
                <div style="font-size:24px;">{{$t('body.news_np2')}}</div>
                <img src="img/fb_like.png" alt style="width:62px; height:35px;" />
                <!-- <div style="margin-top:120px;">{{$t('body.news_np3')}}</div> -->
                <div style="margin-top:120px; text-align:left;">{{item.text}}</div>
              </div>
            </div>
          </div>
        </div>
      </u-animate>
    </u-animate-container>
    <div style="position:relative;top:50px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>
<script>
export default {
  name: "brand",
  data() {
    return {
      cares: [
        [
          {
            link: "img/csr1.jpg",
            text: "Visit Persatuan Kebajikan OKU Hati Berganda Selangor."
          },
          {
            link: "img/csr2.jpg",
            text: "Visit Persatuan Kebajikan OKU Hati Berganda Selangor."
          },
          {
            link: "img/csr3.jpg",
            text: "Visit Persatuan Kebajikan OKU Hati Berganda Selangor."
          }
        ],
        [
          {
            link: "img/csr4.jpg",
            text: "Visit Persatuan Kebajikan OKU Hati Berganda Selangor."
          },
          {
            link: "img/csr5.jpg",
            text: "Visit Persatuan Kebajikan OKU Hati Berganda Selangor."
          },
          {
            link: "img/csr6.jpg",
            text: "Visit Persatuan Kebajikan OKU Hati Berganda Selangor."
          }
        ]
      ]
    };
  },
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
  },
  methods: {
    hilightTableIn(e) {
      let el = e.target;
      el.classList.toggle("over");
    },
    hilightTableOut(e) {
      let el = e.target;
      el.classList.toggle("over");
    }
  }
};
</script>

<style lang="scss" scoped>
.hilight-table {
  background-color: #00354c00;
  background-blend-mode: multiply;
  color: grey;
  padding: 24px;
  font-size: 24px;
  div {
    opacity: 0;
    transition: all 300ms ease-in-out;
  }
  transition: all 300ms ease-in-out;
}
.hilight-table.over {
  background-color: #00354cc4;
  background-blend-mode: multiply;
  div {
    opacity: 1;
    transition: all 300ms ease-in-out;
  }
  transition: all 300ms ease-in-out;
}
</style>